import { lazy } from 'react'
import { RouteType } from './route.types'

export const guestPortalRoutes: RouteType[] = [
  {
    path: '/guest-portal/',
    Component: lazy(() => import('../pages/guest-portal/guest-portal')),
  },
  {
    path: '/guest-portal/reservation-info',
    Component: lazy(() => import('../pages/guest-portal/reservation-info/reservation-info')),
  },
  {
    path: '/guest-portal/self-checkin',
    Component: lazy(() => import('../pages/guest-portal/self-checkin/self-checkin')),
  },
  {
    path: '/guest-portal/additional-services',
    Component: lazy(() => import('../pages/guest-portal/additional-services/additional-services')),
  },
  /* hide for now {
    path: '/guest-portal/bill',
    Component: lazy(() => import('../pages/guest-portal/bill/bill')),
  }, */
  {
    path: '/guest-portal/property-info',
    Component: lazy(() => import('../pages/guest-portal/property-info/property-info')),
  },
]

export const quotationRoutes: RouteType[] = [
  {
    path: '/quotation/',
    Component: lazy(() => import('../pages/quotation/quotation')),
  },
]

export const bookingEngineRoutes: RouteType[] = [
  {
    path: '/booking-engine/:hotelPath',
    Component: lazy(() => import('../pages/booking-engine/booking-engine')),
  },
  {
    path: '/booking-engine/:hotelPath/add-additional-services/',
    Component: lazy(() => import('../pages/booking-engine/add-additional-services/add-additional-services.page')),
  },
  {
    path: '/booking-engine/:hotelPath/confirm-and-pay/',
    Component: lazy(() => import('../pages/booking-engine/confirm-and-pay/confirm-and-pay.page')),
  },
  {
    path: '/booking-engine/:hotelPath/confirm-and-pay/:token',
    Component: lazy(() => import('../pages/booking-engine/confirm-and-pay/confirm-and-pay.page')),
  },
  {
    path: '/booking-engine/:hotelPath/confirmed-reservation/:token',
    Component: lazy(() => import('../pages/booking-engine/confirmed-reservation/confirmed-reservation.page')),
  },
  {
    // in the booking engine route because is a public page
    path: '/quotation-request/:hotelPath',
    Component: lazy(() => import('../pages/booking-engine/quotation-request/quotation-request.page')),
  },
  {
    // in the booking engine route because is a public page
    path: '/confirmed-quotation-request/:hotelPath',
    Component: lazy(() => import('../pages/booking-engine/confirmed-quotation-request/confirmed-quotation-request.page')),
  },
  {
    path: '*',
    Component: lazy(() => import('../pages/404')),
  },
]

export const totemRoutes: RouteType[] = [
  {
    path: '/totem',
    Component: lazy(() => import('../pages/totem/totem')),
  },
  {
    path: '/totem/ocr',
    Component: lazy(() => import('../pages/totem/ocr/ocr')),
    privatePage: true,
  },
  {
    path: '/totem/privacy',
    Component: lazy(() => import('../pages/totem/privacy/privacy')),
    privatePage: true,
  },
]
